import produce from 'immer';
import { CORE_PREFILL_STORE } from '../constants';

const getReducerValue = (reducer, valueChanges, draftState) => {
    if (draftState[reducer]) {
        if (Array.isArray(draftState[reducer])) {
            return [...draftState[reducer], ...valueChanges];
        }

        return { ...draftState[reducer], ...valueChanges };
    }

    return valueChanges;
};

// eslint-disable-next-line import/prefer-default-export
export const rootReducer = reducers => (state, action) => {
    const { type, payload } = action;

    if (type === CORE_PREFILL_STORE) {
        /* eslint-disable-next-line no-param-reassign */
        state = produce(state, (draftState) => {
            Object.keys(payload).forEach((reducer) => {
                draftState[reducer] = getReducerValue(reducer, payload[reducer], draftState);
            });
        });
    }

    return reducers(state, action);
};
